<template>
  <div class="gallery-lightbox">

    <div class="flex images">

      <div class="thumbs">
        <button
          v-for="(thumb, index) of images"
          :key="index"
          class="thumb"
          :class="{ 'active' : activeImage.id === thumb.id }"
          @click="activeImage = thumb"
        >
          <img :src="thumb.path" :alt="product.title">
        </button>
      </div>

      <div class="hero">
          <img :src="activeImage.path" :alt="product.title">
      </div>

    </div>

  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
    images: Array
  },

  data () {
    return {
      activeImage: this.images[0]
    }
  },

  mounted () {
  },
}
</script>

<style scoped lang="scss">
.gallery-lightbox {
  .images {
    font-size: 0;

    @media (min-width: 1024px) { width: 640px; }

    @media (max-width: 600px) {
      flex-direction: column-reverse;
    }

    .thumbs {
        position: relative;
        display: inline-block;
        width: 67px;
        height: 224px;

        margin-right: 3px;

        transition: all 250ms ease-in;

        @media (max-width: 600px) {
          display: flex;
          width: 100%;
          height: 95px;

          overflow-y: hidden;
        }

        @media (min-width: 1025px) {
          width: 110px;
          // height: 545px;
          height: 480px;
          margin-right: 0px;

          overflow: auto;

          &:hover, &:active, &:focus {
              overflow-y: auto;
              transition: all 250ms ease-in;
          }
        }

        .thumb {
          display: flex;
          justify-content: center;
          align-items: center;

          width: 55px;
          height: 55px;
          margin: 0 0 6px;

          cursor: pointer;

          border: 1px solid #d8d8d8;
          background: white;

          @media (max-width: 600px) {
            height: 85px;
            width: 85px;
            min-width: 85px;
            margin-right: 5px;
          }

          @media (min-width: 1025px) {
            width: 90px;
            height: 90px;
          }

          &.active {
            border: 1px solid #1d242c;
          }

          img {
            height: 100%;
            margin: auto;
            object-fit: contain;

            opacity: 0.6;
          }
        }

        .thumb.active img { opacity: 1; }
    }

    .thumbs::-webkit-scrollbar {
      width: 80px;
      height: 5px;

      @media (min-width: 600px) {
        width: 5px;
        height: 80px;
      }
    }


    .thumbs::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
        background-color: transparent;
    }

    .thumbs::-webkit-scrollbar-thumb {
        background-color: #6b6f74;
        border-radius: 10px;
    }


    .hero {
      position: relative;
      display: inline-block;
      width: calc(100% - 70px);

      border: 1px solid #e7e9eb;
      border-radius: 3px;

      @media (max-width: 600px) {
        width: 100%;
        margin-bottom: 10px;
      }

      @media (min-width: 1025px) {
        display: flex;
        width: calc(100% - 110px);
        height: 530px;
        // padding-bottom: 25px;
      }

      a {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;

        background: white;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// resources/assets/frontend/js/modulatte-product/components/Gallery.vue